import { notification } from "./shared/utils.js";

const DEBUG_MESSAGE_LEVEL = "10";
const INFO_MESSAGE_LEVEL = "20";
const SUCCESS_MESSAGE_LEVEL = "25";
const WARNING_MESSAGE_LEVEL = "30";
const ERROR_MESSAGE_LEVEL = "40";

$(() => {
  let messages = document.querySelectorAll(".user-message");
  if (messages) {
    Array.from(messages).forEach((message) => {
      switch (message.dataset.messageLevel) {
        case WARNING_MESSAGE_LEVEL:
        case ERROR_MESSAGE_LEVEL:
          notification.error(message.dataset.messageMessage);
          break;
        case DEBUG_MESSAGE_LEVEL:
        case INFO_MESSAGE_LEVEL:
        case SUCCESS_MESSAGE_LEVEL:
        default:
          notification.success(message.dataset.messageMessage);
      }
    });
  }
});
